// internationalization
import { useTranslation } from 'react-i18next';

// material ui icons
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';

// material ui
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

const DeleteSubscriptionDialog = ({
  open,
  onClose,
  handleDeleteSubscription,
}) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('actions.confirm')}</DialogTitle>
      <DialogContent dividers>
        <Typography>
          {t('subscriptionDialogs.deleteConfirmation', {
            ns: 'buildingOptimization',
          })}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="text">
          {t('actions.cancel')}
        </Button>
        <Button
          onClick={handleDeleteSubscription}
          startIcon={<DeleteRoundedIcon />}
          variant="contained"
          color="error"
        >
          {t('actions.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteSubscriptionDialog;
